import { render, staticRenderFns } from "./bomDetail.vue?vue&type=template&id=2057fe1c&"
import script from "./bomDetail.vue?vue&type=script&lang=js&"
export * from "./bomDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports